var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M905.7,607.2L202,985.4c-84,42-178.6-10.5-178.6-105V124.1c0-94.5,105-157.6,178.6-105l703.7,378.1\n\t\tC1000.2,439.2,1000.2,565.2,905.7,607.2z"})));
}

PlayIcon.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 1000 1000","style":{"enableBackground":"new 0 0 1000 1000"},"xmlSpace":"preserve"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
